import { runClientComponent } from '../../_common/client/client-component-runner';
import { UpInfoComponent } from './up-info.component';

runClientComponent({ UpInfoComponent });
